import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { PERMISSION_VEHICLE } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';
import VehicleDetail from '../../components/VehiclesSettings/VehicleDetail';

// Optional search params (deep-link / row-action filters); never fail validation.
const carsSettingsEditSearchSchema = z.object({
  customerId: z.coerce.number().optional().catch(undefined),
});

export const Route = createFileRoute('/_authenticated/cars_settings/edit/$id')({
  validateSearch: carsSettingsEditSearchSchema,
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_VEHICLE, ['read'], '/unauthorized', context);
    return {
      ...context,
      documentTitle: {
        main: 'table.detail',
        suffix: 'menu.carsSettings',
      },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: RouteView,
});

function RouteView() {
  const { id } = Route.useParams();
  const { customerId } = Route.useSearch();

  return <VehicleDetail id={Number(id)} customerId={customerId} />;
}
